// tslint:disable
export enum TCSPaymentType {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Check to Site
     */
    CheckToSite = 1,
    /**
     * @description Check to Patient
     */
    CheckToPatient = 2,
    /**
     * @description Debit Card
     */
    DebitCard = 3,
    /**
     * @description Check Payable to Site
     */
    CheckPayableToSite = 4,
    /**
     * @description Electronic Funds Transfer
     */
    ElectricFundsTransfer = 5,
}
(TCSPaymentType as any)['NONE'] = 0;
(TCSPaymentType as any)['CHECKTOSITE'] = 1;
(TCSPaymentType as any)['CHECKTOPATIENT'] = 2;
(TCSPaymentType as any)['DEBITCARD'] = 3;
(TCSPaymentType as any)['CHECKPAYABLETOSITE'] = 4;
(TCSPaymentType as any)['ELECTRICFUNDSTRANSFER'] = 5;
